import styled from 'styled-components';

const ErrorWrapper = styled.div`
  padding: 24px;
  padding-top: 72px;
`;

export { ErrorWrapper };
